import { GroupProp } from "../../../components/form-factory/utils/util";
import { IssueTypeList } from "../../../enums/issue-type.enum";

export const Fields = (): GroupProp[] => (
  [
      {
        groupName: "NOTA",
        groupLabel: "Qual o tipo da nota deseja emitir:",
        items: [
          {
            name: "type",
            type: "select",
            validations: "inputRequired",
            label: "Selecione o tipo de nota*:",
            options: IssueTypeList,
            col: {
              xs: 12,
              md: 12,
              lg: 12,
            },
          },
        ],
      },
    ]
);